import { render, staticRenderFns } from "./airplane-travel-a45.vue?vue&type=template&id=00a8ded6"
import script from "./airplane-travel-a45.vue?vue&type=script&lang=js"
export * from "./airplane-travel-a45.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports